@if (show()) {
  <div
    class="kl-alert"
    [class.kl-alert--success]="type() === 'success'"
    [class.kl-alert--error]="type() === 'error'"
    [class.kl-alert--info]="type() === 'info'"
    [class.kl-alert--warning]="type() === 'warning' || type() === 'warn'">
    <div class="kl-alert__inner">
      <div class="kl-alert__icon" aria-hidden="true">
        <i [class]="iconClass()"></i>
      </div>
      <div class="kl-alert__body">
        @if (messageIsString()) {
          <div class="kl-alert__line">
            <span>{{ stringMessage() | translate }}</span>
          </div>
        } @else {
          @if (alertHeader()) {
            <div class="kl-alert__line kl-alert__line--header">
              <button type="button" class="kl-alert__toggle" (click)="toggleMultiMessage()">
                @if (!multiMessageExpanded()) {
                  <i class="ph ph-caret-right" aria-hidden="true"></i>
                } @else {
                  <i class="ph ph-caret-down" aria-hidden="true"></i>
                }
                {{ alertHeader() | translate }}
              </button>
            </div>
          }
          @if (!alertHeader()) {
            <div class="kl-alert__line">
              <button type="button" class="kl-alert__toggle" (click)="toggleMultiMessage()">
                @if (!multiMessageExpanded()) {
                  <i class="ph ph-caret-right" aria-hidden="true"></i>
                } @else {
                  <i class="ph ph-caret-down" aria-hidden="true"></i>
                }
                {{ 'show_messages' | translate }}
              </button>
            </div>
          }
          @if (multiMessageExpanded()) {
            <ul class="kl-alert__list">
              @for (msg of arrayMessage(); track $index) {
                <li>{{ msg | translate }}</li>
              }
            </ul>
          }
        }
      </div>
      @if (showClose()) {
        <button type="button" class="kl-alert__close" (click)="dismiss()" [attr.aria-label]="'close' | translate">
          &times;
        </button>
      }
    </div>
  </div>
}
